import { Directive, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { BasysMapFrameService, PanelComponent } from '@barthauer/basys/map-frame';
import { Observable } from 'rxjs';
import { MobileResourceEventViewModel } from '../../viewModels/mobileData.resources.viewModel';
import { ResourceNavigationComponent } from '../resource-navigation/resource-navigation.component';
import { ResourcesConstants, ResourcesNavigationContext } from '../resources.model';
import { ResourcesService } from '../resources.service';

@Directive()
export abstract class ResourceEventEditBase extends PanelComponent implements OnInit, OnDestroy {
  public res$: Observable<ResourceSet>;
  public resourceManagerService: ResourceManagerService;
  public resourcesNavigationContext: ResourcesNavigationContext;
  public ResourcesConstants = ResourcesConstants;

  public get resourceEvent(): MobileResourceEventViewModel {
    return this.resourcesNavigationContext.resourceEvent;
  }

  public get isDisabled(): boolean {
    return this._isDisabled || this.CompareHelper.isEmptyObject(this.resourceEvent);
  }

  public set isDisabled(value: boolean) {
    this._isDisabled = value;
  }

  private _isDisabled: boolean;
  private resourcesService: ResourcesService;
  @ViewChild(ResourceNavigationComponent, { static: true }) navigation: ResourceNavigationComponent;

  constructor() {
    super();
    this.isDisabled = true;
  }

  protected init(
    frame: BasysMapFrameService,
    resourcesService?: ResourcesService,
    resourceManagerService?: ResourceManagerService
  ) {
    super.init(frame);
    this.resourcesService = resourcesService;
    this.resourceManagerService = resourceManagerService;
    this.res$ = this.resourceManagerService.getResourceSetAsObservable('abc-maintenance-opera');

    this.subscriptions.push(
      this.resourcesService.onNavigationContextRefresh().subscribe((context) => {
        this.resourcesNavigationContext = context;
        this.onNavigationContextRefresh();
      })
    );
  }

  protected onNavigationContextRefresh(): void {}

  protected safeSetValue(evt: any, propName: string): void {
    if (this.resourceEvent) {
      this.resourceEvent[propName] = evt.value;
    }
  }

  async ngOnInit() {
    super.ngOnInit();
    this.subscriptions.push(this.navigation.onAllowDataChanging.subscribe((context) => (this.isDisabled = !context)));
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
